import { TFunction } from "i18next"
import { Risk } from "../model/risk.types"
import { HelpKey, RISK_HELP_ITEMS, RiskHelpItem } from "../model/risk.help.config"

export function getRiskHelpText(id: HelpKey, t: TFunction, risk?: Risk): string {
  const item: RiskHelpItem | undefined = RISK_HELP_ITEMS.find((x) => x.id === id)
  if (!item) return ""

  const title = t(item.name)
  const desc = item.descriptions.map((d) => t(d).replace(/\//g, " /​ ")).join("\n")

  // si c'est un derived metric (rb ou rr), on rajoute la valeur actuelle formatée
  if (item.id === "rb" && risk) {
    const valueLabel = (risk.valueInitialLabel ?? risk.valueInitial)?.toString().replace(/\//g, " /​ ")
    return `${title} (${valueLabel})\n${desc}`
  }
  if (item.id === "rr" && risk) {
    const valueLabel = (risk.valueEffectiveLabel ?? risk.valueEffective)?.toString().replace(/\//g, " /​ ")
    return `${title} (${valueLabel})\n${desc}`
  }

  // pour les simples metrics (f,g,p)
  return `${title}\n${desc}`
}
